import { createReducer } from '@reduxjs/toolkit';
import { getScreenSettingsByScreenNameTableName, screenSettingsResolved, screenSettingsRejected, resetScreenSettingsStatus, addDefaultColumnsToScreenSettings, } from '../actions';
import { MUIX_TABLE_PREFERENCE, MUIX_SCREEN_PREFERENCE, DEFAULT_STORY_BOOK_TABLE_COLUMNS, } from '../types';
const initialScreenSettings = () => {
    const initialSettings = {
        [MUIX_SCREEN_PREFERENCE.STORY_BOOK_TEST]: {
            [MUIX_TABLE_PREFERENCE.STORY_BOOK_TEST]: {
                configs: {
                    columns: DEFAULT_STORY_BOOK_TABLE_COLUMNS,
                    tableName: MUIX_TABLE_PREFERENCE.STORY_BOOK_TEST,
                    screenName: MUIX_SCREEN_PREFERENCE.STORY_BOOK_TEST,
                },
                status: 'idle',
            },
        },
    };
    return initialSettings;
};
export const initialState = {
    screens: initialScreenSettings(),
};
const getStatusPending = (state, payload) => {
    const { tableName, screenName } = payload;
    return {
        ...state,
        screens: {
            ...state.screens,
            [screenName]: {
                ...state.screens[screenName],
                [tableName]: {
                    ...state.screens[screenName][tableName],
                    status: 'pending',
                },
            },
        },
    };
};
const reducer = {
    [resetScreenSettingsStatus.toString()]: (state, action) => {
        const { tableName, screenName } = action.payload;
        return {
            ...state,
            screens: {
                ...state.screens,
                [screenName]: {
                    ...state.screens[screenName],
                    [tableName]: {
                        ...state.screens[screenName][tableName],
                        status: 'idle',
                    },
                },
            },
        };
    },
    [getScreenSettingsByScreenNameTableName.toString()]: (state, action) => {
        return getStatusPending(state, action.payload);
    },
    [screenSettingsResolved.toString()]: (state, action) => {
        const { tableName, screenName } = action.payload.configs;
        return {
            ...state,
            screens: {
                ...state.screens,
                [screenName]: {
                    ...state.screens[screenName],
                    [tableName]: {
                        ...state.screens[screenName][tableName],
                        ...action.payload,
                        status: 'completed',
                    },
                },
            },
        };
    },
    [screenSettingsRejected.toString()]: (state, action) => {
        const { tableName, screenName, defaultColumns } = action.payload;
        return {
            ...state,
            screens: {
                ...state.screens,
                [screenName]: {
                    ...(state.screens[screenName] ?? {}),
                    [tableName]: {
                        ...(state.screens[screenName][tableName] ?? {}),
                        configs: {
                            columns: defaultColumns,
                            tableName,
                            screenName,
                        },
                        status: 'rejected',
                    },
                },
            },
        };
    },
    [addDefaultColumnsToScreenSettings.toString()]: (state, action) => {
        const { tableName, screenName, defaultColumns } = action.payload;
        return {
            ...state,
            screens: {
                ...state.screens,
                [screenName]: {
                    ...(state.screens[screenName] ?? {}),
                    [tableName]: {
                        ...(state.screens[screenName]?.[tableName] ?? {}),
                        configs: {
                            columns: defaultColumns,
                            tableName,
                            screenName,
                        },
                        status: 'idle',
                    },
                },
            },
        };
    },
};
export default createReducer(initialState, reducer);
